import { RoutePathOutputWithOutStatus } from './route-path-output-with-out-status.model';


export class RoutePathSelectByIdOutput implements IRoutePathSelectByIdOutput {
    status!: number;
    message!: string;
    data!: RoutePathOutputWithOutStatus;

    constructor(data?: IRoutePathSelectByIdOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.message = _data["message"];
            this.data = _data["data"] ? RoutePathOutputWithOutStatus.fromJS(_data["data"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RoutePathSelectByIdOutput {
        data = typeof data === 'object' ? data : {};
        let result = new RoutePathSelectByIdOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["message"] = this.message;
        data["data"] = this.data ? this.data.toJSON() : <any>undefined;
        return data; 
    }
}

export interface IRoutePathSelectByIdOutput {
    status: number;
    message: string;
    data: RoutePathOutputWithOutStatus;
}

